const FormikFormWrapperStyle = () => ({
    fullHeight: { height: '100%' },
    form: { display: 'flex', flexWrap: 'nowrap', overflow: 'hidden', width: '100%' },
    fullWidth: { width: '100%' },
});

export default FormikFormWrapperStyle;
